<template>
  <div id="app" class="site">
    <navbar/>
    <router-view class="site-content"/>
    <pagefooter />
  </div>
</template>

<script>
import navbar from "@/components/navbar";
import pagefooter from "@/components/page-footer.vue";

export default {
  name: "App",
  components: {
    navbar,
    pagefooter,
  },
};
</script>



<style lang="scss">

$enable-rounded:   true;
$custom-dark: #40241a;

$theme-colors: (
    "dark":      $custom-dark
);

$body-color: white;


/*
    "primary":    $primary,
    "secondary":  $secondary,
    "success":    $success,
    "info":       $info,
    "warning":    $warning,
    "danger":     $danger,
    "light":      $light,
*/
@import '~bootstrap/scss/bootstrap';


.footer {
  width: 100%;
  height: 60px; /* Set the fixed height of the footer here */
  background-color: $custom-dark;
}


body {
  margin-top: 70px;
  background: #9c786c !important;
  font-family: Georgia, Cambria, 'Times New Roman', serif !important;
}

.card {
  background: #6d4c41 !important;
  border-color: $custom-dark !important;
}

.site {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.site-content {
  flex: 1;
}

</style>
